// extracted by mini-css-extract-plugin
export var icon = "linkList-module--icon--09f2e";
export var links = "linkList-module--links--f8b66";
export var text = "linkList-module--text--7fb24";
export var texts = "linkList-module--texts--9e328";
export var textsFrom1200 = "linkList-module--textsFrom1200--01e1c";
export var textsFrom600 = "linkList-module--textsFrom600--78855";